// 奶水乐园 - 分类模拟数据
export const categories = [
  {
    slug: "cuinai-recipes",
    name: "催奶食谱大全",
    description: "科学催奶，从饮食开始。汇集近百道催奶食谱，涵盖汤品、粥类、饮品等，为妈妈提供全面的营养支持。",
    icon: "ri-bowl-line",
  },
  {
    slug: "milk-boost-tips",
    name: "追奶方法技巧",
    description: "高效追奶实战攻略，包括哺乳姿势调整、喂养频率优化、心理调节等全方位追奶方案。",
    icon: "ri-heart-pulse-line",
  },
  {
    slug: "low-milk-solutions",
    name: "奶水不足怎么办",
    description: "深入分析奶水不足的原因与解决方案，从生理、饮食、作息等多维度帮助妈妈们重拾信心。",
    icon: "ri-emotion-happy-line",
  },
  {
    slug: "milk-storage",
    name: "母乳储存方法",
    description: "正确的母乳储存和解冻方法，确保宝宝随时都能喝到安全、营养的母乳。",
    icon: "ri-fridge-line",
  },
  {
    slug: "feeding-guide",
    name: "新生儿喂养指南",
    description: "从出生到一岁的完整喂养指南，帮助新手妈妈轻松应对各阶段的喂养挑战。",
    icon: "ri-user-heart-line",
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};